/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetExistingContact Input Action
 */

export class GetExistingContactInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public token: string | undefined;
    public email: string | undefined;
    public phone: string | undefined;
    constructor(token : string | undefined, email: string | undefined,phone:string | undefined) {
        this.phone = phone;
        this.email = email;
        this.token = token;
    }
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `SZFEXISTINGCONTACT`;
    public getCacheObjectType = () => 'SZFEXISTINGCONTACT';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetExistingContactData {
    status: boolean;
    id: string | undefined;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createExistingContactInput = (args: Msdyn365.ICreateActionContext, token: string, email: string,phone: string): Msdyn365.IActionInput => {
    return new GetExistingContactInput(token, email,phone);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function existingContactDataAction(input: GetExistingContactInput, ctx: Msdyn365.IActionContext): Promise<IGetExistingContactData> {
    const token = input.token;
    const email = input.email;
    const phone = input.phone;
    const szfCRMDomain = ctx.requestContext.app.config.szfCRMDomain;
    const response = await Msdyn365.sendRequest<any>(`${szfCRMDomain}/api/data/v9.2//contacts?$select=emailaddress1,firstname,lastname,mobilephone &$filter=emailaddress1 eq \'${email}\' or mobilephone eq \'%2B${phone}\'`, "get", {}, {
        headers: {
            'Authorization':`Bearer ${token}`
        }
    });
    if(response && response.data && response.data.value && response.data.value.length > 0 && response.data.value[0].contactid){
        return {
            status: true,
            id: response.data.value[0].contactid
        };
    }else{
        return {
            status: false,
            id: undefined
        };
    }
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGetExistingContactData[]>('/get/example/id/1', 'get');
    // return { text: 'Static data from action' };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetExistingContactData>>existingContactDataAction,
    // TODO: Give your data action a unique id
    id: 'GetExistingContact',
    input: createExistingContactInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
